import React from 'react'

/**
 * Alternative to the original React.useCallback hook
 * The resulting function will always be the same but will always be fresh thus sparing a lot of dependency comparisons and re-renders
 * @see https://github.com/facebook/react/issues/16956 - Follow this issue to find out if this is a good practice or not
 *
 * @param {Function} callback - the callback to be memoized
 * @return {Function} The memoized callback
 */
export default function useHandler(callback) {
  // create ref
  const ref = React.useRef()
  // update ref with new callback each time
  ref.current = callback
  // return a callback that will apply the fresh provided callback in ref
  return React.useRef((...args) => ref.current.apply(this, args)).current
}
